// Targets are resolved from the live dashboard, never from saved permissions.
export const memberOrientationSteps = [
  { key: 'tiles', selector: '[data-test="home-tiles"]', required: true },
  { key: 'me', selector: '[data-test="tile"][data-tile="me"]' },
  { key: 'admin', selector: '[data-test="tile"][data-tile="admin"]' },
  { key: 'help', selector: '[data-test="help-trigger"]', required: true },
  { key: 'account', selector: '[data-test="user-menu.trigger"]', menu: true },
  { key: 'profile', selector: '[data-test="user-menu.profile"]', menu: true },
  { key: 'push', selector: '[data-test="user-menu.push"]', menu: true },
  { key: 'notifications', selector: '[data-test="user-menu.notifications"]', menu: true }
]
